import { createSelector } from '@reduxjs/toolkit'

import { RootState } from '../store'

const getPaymentsState = (state: RootState) => state?.payments

const getPaymentsDashboard = createSelector(getPaymentsState, (paymentsState) => paymentsState?.paymentsDashboard)

export const getPaymentsData = createSelector(
  getPaymentsDashboard,
  (paymentsDashboard) => paymentsDashboard?.paymentsData,
)

export const getPaymentsBalances = createSelector(getPaymentsDashboard, (dashboard) => dashboard.balances)

export const getPaymentsDataAllData = createSelector(getPaymentsData, (paymentsData) => paymentsData?.all?.data)
